export const TRANSITION_DURATION_MOBILE = 10000
export const TRANSITION_DURATION_DESKTOP = 7000
